import { Required, Schema, TextField } from "lego-gui-lib/lib";
import { mainStore, api } from "../../../core/mainStore";
import i18next from "i18next";
import { ListFKDataSource } from "../schema";
import { Auth } from "../../../core/model/auth";
import { EntriesDataSource } from "./EntriesDataSource";
import { createContext } from "react";

// @ts-ignore
const t = (...args: unknown[]): string => () => i18next.t(...args);

export const ListEntrySchema = new Schema({
  fields: [
    {
      name: "listRef",
      title: t("hns:listEntry:parentName"),
      type: ListFKDataSource,
      readonly: true
    },
    {
      name: "entry",
      title: t("common:entry"),
      type: TextField(Required)
    }
  ],
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANYONE,
    editableRole: Auth.Roles.ANYONE_WITH_WRITE
  }
});

export const ListEntrySchemaColumns = ListEntrySchema.extend({
  listRef: false
});

export const ReadOnlyListEntrySchema = ListEntrySchema.extend({
  entry: {
    readonly: true
  }
});

mainStore.listEntry = EntriesDataSource.create({
  parent: mainStore.list.oneDataSource,
  api: api,
  name: "listEntry",
  schema: ListEntrySchema,
  url: "/entries",
  commons: mainStore.commons
});

export const listEntryContext = createContext(mainStore.listEntry);
